"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSOMigratePage = exports.SSOMigratePageConfig = void 0;
var tslib_1 = require("tslib");
var centered_card_1 = require("../../components/centered.card/centered.card");
var theme_1 = require("../../components/theme");
var theme_2 = require("../../components/theme");
var migrate_user_1 = require("../../modules/auth/migrate.user");
var page_1 = require("../page");
var CSS = {
    container: 'c-MigratePage__container',
    card: 'c-MigratePage__Card',
    button: 'c-MigratePage__action',
    padding: 'c-MigratePage__spacing',
    centered: 'c-MigratePage_centered'
};
var Style = (_a = {},
    _a[CSS.padding] = {
        paddingTop: theme_2.DefaultTheme.space(6)
    },
    _a[CSS.button] = {
        width: '100%'
    },
    _a[CSS.container] = {
        width: '100%',
        height: "calc(100vh - ".concat(theme_2.DefaultTheme.space(6), ")"),
        paddingTop: theme_2.DefaultTheme.space(6)
    },
    _a[CSS.centered] = {
        transform: 'translateX(50vw) translateY(50vh)',
        marginLeft: '-12px',
        marginTop: '-12px'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.SSOMigratePageConfig = {
    type: 'internal',
    name: page_1.IkePageName.userSSOMigrate,
    path: '/auth/migrate',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
var SSOMigratePage = /** @class */ (function (_super) {
    tslib_1.__extends(SSOMigratePage, _super);
    function SSOMigratePage() {
        var _this = _super.call(this, exports.SSOMigratePageConfig) || this;
        _this.name = 'SSOMigratePage';
        _this.component = new migrate_user_1.UserSelfMigrate();
        return _this;
    }
    Object.defineProperty(SSOMigratePage.prototype, "nodes", {
        get: function () {
            return centered_card_1.CenteredCard.view(this.component.view(), { className: CSS.card });
        },
        enumerable: false,
        configurable: true
    });
    return SSOMigratePage;
}(page_1.IkePage));
exports.SSOMigratePage = SSOMigratePage;
//# sourceMappingURL=migrate.page.js.map